import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Instagram, Twitter, Heart, MessageCircle, Share2 } from 'lucide-react';
interface SocialPost {
  platform: 'instagram' | 'twitter';
  username: string;
  handle: string;
  content: string;
  likes: number;
  comments: number;
  timeAgo: string;
}
const posts: SocialPost[] = [{
  platform: 'instagram',
  username: 'Camila Torres',
  handle: '@camitorres.fit',
  content: 'Llevo 2 semanas aplicando el Motor 3-Loop y ya cerré mi primera venta por DM 🤯 Sin hacer reels virales, sin bailar, sin mostrar mi vida privada. Solo contenido con intención. Gracias @ingresosatomicos 🔥',
  likes: 247,
  comments: 34,
  timeAgo: '2d'
}, {
  platform: 'twitter',
  username: 'Andrés Mendoza',
  handle: '@andresmendozamkt',
  content: 'Antes publicaba 7 veces a la semana y no vendía nada.\n\nAhora publico 4 y genero ingresos cada semana.\n\nLa diferencia: dejé de crear contenido "bonito" y empecé a crear contenido que convierte.\n\nEl ebook de Ingresos Digitales Atómicos me abrió los ojos. 💡',
  likes: 512,
  comments: 67,
  timeAgo: '5d'
}, {
  platform: 'instagram',
  username: 'Sofía Guzmán',
  handle: '@sofi.disena',
  content: 'Story time: compré este ebook pensando "otro más"… pero los prompts atómicos son OTRA COSA. Literalmente escribí 2 semanas de contenido en una tarde. Mi engagement subió y ya tengo 3 clientes nuevos este mes 📈✨',
  likes: 389,
  comments: 52,
  timeAgo: '1sem'
}, {
  platform: 'twitter',
  username: 'Diego Herrera',
  handle: '@diegoherrera_',
  content: 'El concepto de "Puente a Oferta" del ebook Ingresos Digitales Atómicos es brillante.\n\nAntes: "compra mi curso" (silencio total)\nAhora: mis seguidores me piden el link.\n\nCambio de paradigma total. 🧠',
  likes: 198,
  comments: 28,
  timeAgo: '3d'
}];
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.12,
      duration: 0.5,
      ease: 'easeOut'
    }
  })
};
function formatNumber(n: number): string {
  return n >= 1000 ? `${(n / 1000).toFixed(1)}k` : n.toString();
}
export function SocialTestimonials() {
  return <Section className="bg-[#0f0f0f]" data-id="element-286">
      <div className="text-center mb-8" data-id="element-287">
        <p className="text-[#14b8a6] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-288">
          Lo dicen en redes
        </p>
        <h2 className="text-2xl md:text-3xl font-black text-white" data-id="element-289">
          Publicaciones reales de quienes ya aplican el método
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-290">
        {posts.map((post, i) => <motion.div key={i} custom={i} variants={cardVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} className="bg-white border border-gray-200 rounded-lg p-3.5 flex flex-col" data-id="element-291">
            {/* Header */}
            <div className="flex items-center gap-2 mb-2.5" data-id="element-292">
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#14b8a6]/10 to-[#06b6d4]/10 border border-gray-200 flex items-center justify-center" data-id="element-293">
                {post.platform === 'instagram' ? <Instagram size={14} className="text-[#14b8a6]" data-id="element-294" /> : <Twitter size={14} className="text-[#06b6d4]" data-id="element-295" />}
              </div>
              <div className="flex-1 min-w-0" data-id="element-296">
                <p className="text-gray-900 text-xs font-semibold truncate" data-id="element-297">
                  {post.username}
                </p>
                <p className="text-gray-400 text-[10px]" data-id="element-298">{post.handle}</p>
              </div>
              <span className="text-gray-400 text-[10px]" data-id="element-299">{post.timeAgo}</span>
            </div>

            {/* Content */}
            <p className="text-gray-700 text-xs leading-relaxed mb-3 flex-1 whitespace-pre-line" data-id="element-300">
              {post.content}
            </p>

            {/* Engagement */}
            <div className="flex items-center gap-4 pt-2.5 border-t border-gray-100" data-id="element-301">
              <div className="flex items-center gap-1 text-gray-400 text-[10px]" data-id="element-302">
                <Heart size={12} className="text-red-400" data-id="element-303" />
                <span data-id="element-304">{formatNumber(post.likes)}</span>
              </div>
              <div className="flex items-center gap-1 text-gray-400 text-[10px]" data-id="element-305">
                <MessageCircle size={12} data-id="element-306" />
                <span data-id="element-307">{formatNumber(post.comments)}</span>
              </div>
              <div className="flex items-center gap-1 text-gray-400 text-[10px] ml-auto" data-id="element-308">
                <Share2 size={12} data-id="element-309" />
              </div>
            </div>
          </motion.div>)}
      </div>
    </Section>;
}